import React, {Component} from 'react';
import jsxToString from 'jsx-to-string';
import firebase from '../../Firebase';
import { weight_for_age_boys, weight_for_age_girls, length_height_for_age_boys, length_height_for_age_girls } from '../constants';


class Bmi extends Component {
  constructor() {
    super();
    this.state = {
      response: {
        success: false,
        warning: null,
        error: null,
        message: null,
        data: null,
        weight_status: null,
        height_status: null,
        weight_height_status: null,
        growth_problem: null,
        growth_problem_message: null,
        found_problem: false,
        warning_problem: null,
        problem_submitted: false,
        growth_message: null,
        insertID: null,
      }
    };
    
  }

  resetState = () => {
    const {insertID} = this.state.response;
    let response ={
      success: false,
      warning: null,
      error: null,
      message: null,
      data: null,
      weight_status: null,
      height_status: null,
      weight_height_status: null,
      growth_problem: null,
      growth_problem_message: null,
      found_problem: false,
      warning_problem: null,
      problem_submitted: false,
      growth_message: null,
      insertID: insertID,
    }

      this.state.response = response;

  }

 getAgeVsMetricData = (metric,sex) => {
    var sexgroup;
    var metric_data;
    if(sex == 'M'){
      if(metric == 'height')
        metric_data = length_height_for_age_boys;
      else
        metric_data = weight_for_age_boys;
    }
    else{
      if(metric == 'height')
        metric_data = length_height_for_age_girls;
      else
        metric_data = weight_for_age_girls;
    }

    return metric_data;
  }

  getGrowthProgressData = (metric,range,Child, User) => {
    const data = [];
    var growth_chart_data = [];

    this.ProgressTableRef = firebase.firestore().collection('users').doc(User.key).collection('children').doc(Child.key).collection('children_progress').orderBy("recording_time", "asc");
   
    return this.ProgressTableRef.get().then((querySnapshot) => {
      if(!querySnapshot.empty){
        var j = 0;
        querySnapshot.forEach((doc) => {
          const row = doc.data();

          const recording_time = new Date(row.recording_time);
          const birth_date = new Date(Child.birth_date);

          const dobstamp = birth_date.getTime();
          const todaystamp = recording_time.getTime();
          const agestamp_temp = todaystamp-dobstamp;
          const agestamp = new Date(agestamp_temp);
          var years = agestamp.getFullYear();
          years = years-1970;
          var months = agestamp.getMonth();
          // months = months-1;
          var days = agestamp.getDate();
          days = days-1;
          const total_days = (agestamp_temp/(1000 * 60 * 60 * 24));
          const total_months = (months)+(years * 12);
          const total_weeks = Math.floor(total_days/7);

          if(range == 'months')
            row['months'] = total_months;
          else if(range == 'weeks')
            row['weeks'] = total_weeks;
          else if(range == 'days')
            row['days'] = days;

          data.push(row);
        });
        data.reverse();//Reverse array elements order to fetch the most current first
        const count = data.length;
        var j;
        for(j=0;j<count;j++) {
          if(j===0)
            growth_chart_data.push(data[j]);
          else{
            if(data[j][range] == data[j-1][range])
              continue;
            growth_chart_data.push(data[j]);
          }
        }
        growth_chart_data.reverse();//Reverse array elements order to start with old data
        return {success: true, error: null, data: growth_chart_data};

      }
      else{
        return {success: false, error: 'No progress data recorded for this child', data: []};
        // window.history.back();
      }

    }).catch((error) => {
      return {success: false, error: "Data can't be fetched("+error+")", data: []}

      // window.history.back();
    });
   
  }

  confirmGrowth = (weight, height, sex, age, firstname, translation,child_id) => {
    var response = this.state.response;
    var pronoun = '';
    var sexgroup = 'girls';
    var measurement = 'length';
    if(sex == 'M')
      pronoun = translation['male_possessive_pronoun'];
    else if(sex == 'F')
        pronoun = translation['female_possessive_pronoun'];

    if(age > 60){
      response.error = firstname+" "+translation['metrics_age_error_a']+" "+pronoun+" "+translation['metrics_age_error_b'];
      response.success = false;
      this.state.response = response;
      // this.setState({response});
      return false;
    }
    else{
      if(sex == 'M')
        sexgroup = 'boys';
    
      if(age > 24)
        measurement = 'height';

      const weight_table = 'weight_for_age_'+sexgroup;
      const height_table = 'length_height_for_age_'+sexgroup;
      const weight_height_table = 'weight_for_'+measurement+'_'+sexgroup;

      this.WTableRef = firebase.firestore().collection(weight_table).where("Month", "==", ""+age+"");
      this.HTableRef = firebase.firestore().collection(height_table).where("Month", "==", ""+age+"");
      this.WHTableRef = firebase.firestore().collection(weight_height_table).where(""+measurement+"", "==", ""+height+"");
      return this.WTableRef.get().then((querySnapshot) => {

        const weightDataTemp = [];
        querySnapshot.forEach((doc) => {
          weightDataTemp.push(doc.data());
        });

        return this.HTableRef.get().then((querySnapshot) => {
          const heightDataTemp = [];
          querySnapshot.forEach((doc) => {
            heightDataTemp.push(doc.data());
          });

          return this.WHTableRef.get().then((querySnapshot) => {

            const WHDataTemp = [];
            querySnapshot.forEach((doc) => {
              WHDataTemp.push(doc.data());
            });

            if(weightDataTemp.length === 0 || heightDataTemp.length === 0 || WHDataTemp.length === 0){
              response.error = translation['metrics_height_error'];
              response.success = false;
              this.state.response = response;
              // this.setState({response});
              return false;
            }
            else{
              const weightData = weightDataTemp[0];
              const heightData = heightDataTemp[0];
              const WHData = WHDataTemp[0];
              response.growth_problem_message = jsxToString(<b>{translation['metrics_warning_title']+" "+firstname}</b>);
              this.state.response = response;
              var growth_problem = '';

              //convert weight & height string to float ready for logic calculations
              weight = parseFloat(weight);
              height = parseFloat(height);

              if(weight < parseFloat(weightData['-3SD_w']))
                response.weight_status = <font color="#ff0000">{translation['metrics_warning_severe_under_WA_status']}</font>;
              else if(weight < parseFloat(weightData['-2SD_w']))
                response.weight_status = <font color="#ffc300">{translation['metrics_warning_moderate_under_WA_status']}</font>;

              if(height < parseFloat(heightData['-3SD_lh']))
                response.height_status = <font color="#ff0000">{translation['metrics_warning_severe_under_HA_status']}</font>;
              else if(height < parseFloat(heightData['-2SD_lh']))
                response.height_status = <font color="#ffc300">{translation['metrics_warning_moderate_under_HA_status']}</font>;
              else if(height > parseFloat(heightData['3SD_lh']))
                response.height_status = <font color="#ff0000">{translation['metrics_warning_severe_over_HA_status']}</font>;

              const BMI = weight/((height*0.01)*(height*0.01));
              if(BMI >= 25 && BMI <= 30)
                response.weight_height_status  = <font color="#ffc300">{translation['metrics_warning_moderate_over_WH_status']}</font>;
              else if(BMI > 30)
                response.weight_height_status  = <font color="#ff0000">{translation['metrics_warning_severe_over_WH_status']}</font>;

              this.state.response = response;
              // this.setState({response});

              if(response.weight_status != null || response.height_status != null|| response.weight_height_status != null){         
                
                if(response.weight_status != null){
                growth_problem += jsxToString(<h5><b>W/A:</b> {response.weight_status}</h5>);
                }
                if(response.height_status != null){
                  growth_problem += jsxToString(<h5><b>H/A:</b> {response.height_status}</h5>);
                }
                if(response.weight_height_status != null){
                  growth_problem += jsxToString(<h5><b>W/H:</b> {response.weight_height_status}</h5>);
                }

                response.growth_problem = growth_problem;
                response.found_problem = true;
                response.success = true;
                this.state.response = response;
                // this.setState({response});

                return true;
              }
              else{
                this.ProgressTableRef = firebase.firestore().collectionGroup('children_progress').where("child_id", "==", ""+child_id+"").orderBy("recording_time", "desc");
                return this.ProgressTableRef.get().then((querySnapshot) => {
                  const progressDataTemp = [];
                  querySnapshot.forEach((doc) => {
                    progressDataTemp.push(doc.data());
                  });
                  if(progressDataTemp.length !== 0) {
                    const progressData = progressDataTemp[0];
                  if(weight < parseFloat(progressData['weight']))
                    response.growth_message = translation['metrics_success_ax']+' '+firstname+' '+translation['metrics_success_bx']+'.';
                  else
                    response.growth_message = translation['metrics_success_a']+' '+'<br/>'+firstname+' '+translation['metrics_success_b']+'.';
                    response.found_problem = false;
                  }
                  
                  response.success = true;
                  this.state.response = response;
                  // this.setState({response});
                  return true;

                }).catch((error) => {
                  response.error = "Submit Failed"+error;
                  response.success = false;
                  this.state.response = response;
                  // this.setState({response});
                  return false;
                });

              }

            }

          }).catch((error) => {
            response.error = "Submit Failed"+error;
            response.success = false;
            this.state.response = response;
            // this.setState({response});
            return false;
          });
        }).catch((error) => {
          response.error = "Submit Failed"+error;
          response.success = false;
          this.state.response = response;
          // this.setState({response});
          return false;
        });
      }).catch((error) => {
        response.error = "Submit Failed"+error;
        response.success = false;
        this.state.response = response;
        // this.setState({response});
        return false;
      });
    }
  }

  addProgress = async (weight, height, hivstatus, milkfeeding, milkfeedingfrequency, mealfeeding, energy, protein, vitaminA, vitaminC, vitaminD, vitaminE, bmi_message, bmi_warning, feeding_message, feeding_warning, childID, months, weeks, days, translation, user_key, child_key) =>{
    const response = this.state.response;
    if (weight > 30) {
        // response.error = translation['metrics_weight_error'];
        this.state.response.error = translation['metrics_weight_error'];
        this.state.response.success = false;
        return false;
    }
    else{

      this.AddProgressTableRef = firebase.firestore().collection("users").doc(user_key).collection("children").doc(child_key).collection('children_progress');
      let currentTime= new Date();
      let children_progress_id = childID+""+currentTime.getTime();
      let Year = currentTime.getUTCFullYear() < 10 ? "0"+currentTime.getUTCFullYear() : currentTime.getUTCFullYear();
      let Month = currentTime.getUTCMonth();
      Month += 1;
      Month = Month < 10 ? "0"+Month : Month;
      let Datex = currentTime.getUTCDate() < 10 ? "0"+currentTime.getUTCDate() : currentTime.getUTCDate();
      let Hours = currentTime.getUTCHours() < 10 ? "0"+currentTime.getUTCHours() : currentTime.getUTCHours();
      let Minutes = currentTime.getUTCMinutes() < 10 ? "0"+currentTime.getUTCMinutes() : currentTime.getUTCMinutes();
      let Seconds = currentTime.getUTCSeconds() < 10 ? "0"+currentTime.getUTCSeconds() : currentTime.getUTCSeconds();
      
      let currentDateTime = Year+"-"+Month+"-"+Datex+" "+Hours+":"+Minutes+":"+Seconds;
      
      this.AddProgressTableRef.doc(children_progress_id).set(
        {
          "child_progress_id": children_progress_id,
          "weight": weight,
          "height": height,
          "hiv_status": hivstatus,
          "milk_feeding": milkfeeding,
          "milk_feeding_frequency": milkfeedingfrequency,
          "meal_feeding": mealfeeding,
          "energy": energy,
          "protein": protein,
          "vitaminA": vitaminA,
          "vitaminC": vitaminC,
          "vitaminD": vitaminD,
          "vitaminE": vitaminE,
          "bmi_message": bmi_message,
          "bmi_warning": bmi_warning,
          "feeding_message": feeding_message,
          "feeding_warning": feeding_warning,
          "child_id": childID,
          "months": months,
          "weeks": weeks,
          "days": days, 
          "recording_time": currentDateTime
        }
      )
      .catch((error) => {
        // response.error = "Submit Failed"+error;
        this.state.response.error = "Submit Failed "+error;
        this.state.response.success = false;
        return false;
      });

      this.state.response.insertID = children_progress_id;
      this.state.response.success = true;

      localStorage.setItem('child_progress_id', JSON.stringify(children_progress_id));

      return true;

    }
  }

  updateBmiMessages = async (message, warning, progress_id, user_key, child_key) => {
    this.AddProgressTableRef = firebase.firestore().collection("users").doc(user_key).collection("children").doc(child_key).collection('children_progress');
    this.AddProgressTableRef.doc(progress_id).update(
      {
        "bmi_message": message,
        "bmi_warning": warning
      }
    ).catch((error) => {
      this.state.response.error = "Results messages was not Saved: "+error;
      this.state.response.success = false;
      return false
    });

    this.state.response.success = true;
    return true;

  }

  create = (data, Child, User, age, Translator) => {

    this.resetState();
    let weight = data.weight;
    let height = data.height;

    //Make weight to decimal point
    let weight_int = Math.floor(weight);
    let weight_dec = weight - weight_int;
    weight = weight_int+weight_dec;

    let height_int = Math.floor(height);
    let height_dec = height - height_int;

    if(height_dec >= 0.1 && height_dec < 0.6)
      height = height_int+0.5;
    else if(height_dec >= 0.6)
      height = height_int+1;
    else
      height = height_int;
    
    //convert weight and height to 1 decimal point
    height = height.toFixed(1);
    weight = weight.toFixed(1);

   

    return this.confirmGrowth(weight, height, Child.sex, age.total_months, Child.first_name, Translator,Child.child_id).then((response) => {
      
      if(!response)
        return this.state.response;
      else{

        return this.addProgress(weight,height,'','','','','','','','','','','','','','',Child.child_id,age.total_months,age.total_weeks,age.total_days,Translator, User.key, Child.key).then((response) => {
          
          if(!response){
            return this.state.response;
          }
          else{
            
            if(this.state.response.found_problem){

              const warning = this.state.response.growth_problem_message;
              const problem = this.state.response.growth_problem;
              const warning_problem = warning+" "+problem;
              this.state.response.warning_problem = warning_problem;

              return this.updateBmiMessages('',warning_problem,this.state.response.insertID, User.key, Child.key).then((response) => {

                if(!response)
                  return this.state.response;
                else{
                  this.state.response.problem_submitted = true;
                  return this.state.response;
                }

              }).catch((error) => {
                alert(error);
              });

            }
            else{
              const message = this.state.response.growth_message;
              return this.updateBmiMessages(message,'',this.state.response.insertID, User.key, Child.key).then((response) => {
                if(!response){
                  return this.state.response;
                }
                else{
                  return this.state.response;
                }
              }).catch((error) => {
                alert(error);
              });
            }

          }

        }).catch((error) => {
          alert(error);
        });          

      }

    }).catch((error) => {
        alert(error);
    });


    // const { weight, height } = this.state;

    // this.ref.add({
    //   weight,
    //   height
    // }).then((docRef) => {
    //   this.setState({
    //     weight: '',
    //     height: ''
    //   });
    //   this.props.history.push("/")
    // })
    // .catch((error) => {
    //   console.error("Error adding document: ", error);
    // });

    // if(!navigator.onLine)
    //   this.props.history.push("/")
  }
}

export const BmiController = new Bmi();